<template>
<div class="champion-wrap">
    <h2 class="champion-label">ドラッグレース全日本チャンピオン</h2>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('90')"><span class="history__head--circle">1993-2000</span></button>
        <div class="champions">
            <section class="champions__sec">
                <h2 class="year-title">1993年<span class="year-title__sub">平成5年</span></h2>
                <ul>
                    <li>田中文樹／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1994年<span class="year-title__sub">平成6年</span></h2>
                <ul>
                    <li>田中文樹／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1995年<span class="year-title__sub">平成7年</span></h2>
                <ul>
                    <li>上中靖司／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1996年<span class="year-title__sub">平成8年</span></h2>
                <ul>
                    <li>生田目俊之／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1997年<span class="year-title__sub">平成9年</span></h2>
                <ul>
                    <li>川上英二／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1998年<span class="year-title__sub">平成10年</span></h2>
                <ul>
                    <li>中村圭志／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1999年<span class="year-title__sub">平成11年</span></h2>
                <ul>
                    <li>中村圭志／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2000年<span class="year-title__sub">平成12年</span></h2>
                <ul>
                    <li>赤池真一／プロストックバイクA級</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('100')"><span class="history__head--circle">2001-2008</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">2001年<span class="year-title__sub">平成13年</span></h2>
                <ul>
                    <li>中村圭志／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2002年<span class="year-title__sub">平成14年</span></h2>
                <ul>
                    <li>田中文樹／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2003年<span class="year-title__sub">平成15年</span></h2>
                <ul>
                    <li>中村圭志／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2004年<span class="year-title__sub">平成16年</span></h2>
                <ul>
                    <li>中村圭志／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2005年<span class="year-title__sub">平成17年</span></h2>
                <ul>
                    <li>阿部 巌／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2006年<span class="year-title__sub">平成18年</span></h2>
                <ul>
                    <li>阿部 巌／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2007年<span class="year-title__sub">平成19年</span></h2>
                <ul>
                    <li>中村圭志／プロストックバイクA級</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2008年<span class="year-title__sub">平成20年</span></h2>
                <ul>
                    <li>中村圭志／プロストックバイクA級</li>
                </ul>
            </section>
        </div>
    </div>
</div>
</template>

<script>
    import Mixin from '@/mixins/mixin.js'
    export default {
        data: function() {
            return {
                show_contents: ['90']
            }
        },
        mixins: [Mixin],
    }
</script>

<style lang="scss">

</style>